"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.sortComparator = function (defaultA, defaultB, currentA, currentB, isAscending) {
  // Sort in ascending order
  var ascending = isAscending && currentA > currentB; // Sort in descending order

  var descending = !isAscending && currentA < currentB; // Sort in ascending order by default column if current cells are equal

  var ascendingByDefault = isAscending && currentA === currentB && defaultA > defaultB; // Sort in descending order by default column if current cells are equal

  var descendingByDefault = !isAscending && currentA === currentB && defaultA < defaultB;
  return ascending || descending || ascendingByDefault || descendingByDefault ? 1 : -1;
};

exports.searchComparator = function (firstStr, secondStr) {
  firstStr = firstStr.toLowerCase();
  secondStr = secondStr.toLowerCase();
  return secondStr.length === 1 ? firstStr[0] === secondStr[0] : firstStr.includes(secondStr);
};

exports.handleSortBy = function (value, sortBy) {
  switch (sortBy) {
    case 'alpha':
      return value.toLowerCase();

    case 'datetime':
      var date = new Date(value);
      return date.getTime();

    case 'number':
      return parseInt(value, 10);

    default:
      return value;
  }
};